import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { ReactNode } from 'react';

import RichText from '@/app/components/RichText';

import QuoteSlider from './QuoteSlider';

const tValues = {
  i: (chunks: ReactNode) => <em className="font-serif italic">{chunks}</em>,
};

const GiftTestimonials = () => {
  return (
    <section className="bg-sandstone-100 py-32">
      <Typography align="center" className="mb-16" variant="h2" Element="h3">
        <RichText
          messageKey="pdp_horizon_quote_slider_title"
          tValues={tValues}
        />
      </Typography>
      <QuoteSlider />
    </section>
  );
};

export default GiftTestimonials;
